import React, { useEffect } from 'react';
import './academic.css';
import { Link } from 'react-router-dom';
import Navigation from '../navigationbar/navigationBar';
import { academicProjects } from '../../helpers/cardsLinks';
import ScrollToTop from '../../components/ScrollToTop';

function Academic() {
  useEffect(() => {
    document.title = 'Academic & Concept Projects - Katelin Reilly';
  }, []);

  return (
    <div className="academic-page">
      <Navigation />

      <div className="academic-hero">
        <h1>Academic & Concept Projects</h1>
        <p className="academic-intro">
          Foundational UX work from my UX/UI studies at George Washington University — research, prototyping, and end-to-end product thinking.
        </p>
      </div>

      <div className="academic-projects-grid">
        {academicProjects.map((project) => (
          <div key={project.id} className="academic-card">
            <div className="academic-card-image">
              <img src={project.image} alt={project.title} loading="lazy" />
            </div>
            <div className="academic-card-content">
              <div className="academic-tags">
                {project.tags && project.tags.map((tag, idx) => (
                  <span key={idx} className="academic-tag">{tag}</span>
                ))}
              </div>
              <h3>{project.title}</h3>
              <ul className="academic-features">
                <li>{project.li1}</li>
                <li>{project.li2}</li>
                <li>{project.li3}</li>
              </ul>
              <p className="academic-impact">{project.impact}</p>
              <Link to={project.connect} className="academic-link">
                View Case Study →
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="academic-back">
        <Link to="/" className="back-to-home">← Back to Main Portfolio</Link>
      </div>

      <ScrollToTop />
    </div>
  );
}

export default Academic;